<div class="container" *ngIf="slides.length > 0">
    <swiper-container class="mySwiper" effect="cards" grab-cursor="true">
        <swiper-slide
            *ngFor="let slide of slides"
            (click)="openPopup(slide)"
        >
            <div id="card_{{ slide?.id }}" class="content-container">
                <div class="media-frame">
                    <ng-container
                        *ngIf="slide?.type === 'image'; else videoTemplate"
                    >
                        <img src="{{ base_url + slide?.mediaUrl }}" />
                    </ng-container>

                    <ng-template #videoTemplate>
                        <img
                            *ngIf="slide?.type === 'video'"
                            src="../../../assets/images/play_video.png"
                            (click)="openPopup(slide)"
                        />
                    </ng-template>
                </div>

                <div class="card-content" (click)="openPopup(slide)">
                    <span
                        [innerHTML]="slide?.title | truncate : 50"
                        class="titleCard"
                    ></span>
                    <mat-icon class="icon-right">keyboard_arrow_down</mat-icon>
                </div>
            </div>
        </swiper-slide>
    </swiper-container>
</div>
